/* eslint no-unused-vars: */
import React from "react";
import moment from "moment";
import { Column } from "material-table";
import { capitalize } from "lodash";
import { Box, Chip } from "@material-ui/core";
import { currencyTHB } from "../../../../utils/formatCurrency";
import { getOrdinalSuffix } from "../../../../utils/number";

export const getColumnsTableTransactionReport = ({ options }) => {
    const paymentColumns = options?.payment?.reduce((result, payment) => {
        result[payment?.paymentMethodId] = payment?.name;
        return result;
    }, {});

    /** @type Column */
    const column = [
        {
            field: "bookingNo",
            title: "Booking ID",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "studentName",
            title: "Student",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "bookingDate",
            title: "Date of booking",
            cellStyle: { textAlign: "left" },
            render: obj => {
                return obj?.Order?.OrderLists?.filter(item => item?.bookingDate)
                    ?.map(item => (item?.bookingDate ? moment(item?.bookingDate).format("DD/MM/YYYY") : ""))
                    ?.join(", ");
            },
        },
        {
            field: "name",
            title: "Product",
            cellStyle: { textAlign: "left" },
            render: obj => {
                return obj?.Order?.OrderLists?.map(item => item?.name)?.join(", ");
            },
        },
        {
            field: "name",
            title: "Tags",
            cellStyle: { textAlign: "left" },
            render: obj => {
                const orderLists = obj?.Order?.OrderLists || [];
                const tags = [];
                if (orderLists?.length) {
                    for (const ol of orderLists) {
                        if (ol?.CourseMenu?.CourseMenuHasTags?.length) {
                            tags.push(...ol?.CourseMenu?.CourseMenuHasTags?.map(v => v?.Tag));
                        }
                        if (ol?.Course?.CourseHasTags?.length) {
                            tags.push(...ol?.Course?.CourseHasTags?.map(v => v?.Tag));
                        }
                    }
                }
                return (
                    <Box display="flex" alignItems="center" gridGap={3} flexWrap="wrap">
                        {tags?.map(item => (
                            <Chip size="small" key={`${obj?.orderHasPaymentId}_${item?.tagId}`} label={item?.tagName} />
                        ))}
                    </Box>
                );
            },
        },
        {
            field: "saleTotal",
            title: "Sale Total",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.saleTotal)}</div>,
        },
        {
            field: "transactionDate",
            title: "Date & Time of Transaction",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "orderHasPaymentId",
            title: "Transaction ID",
            cellStyle: { textAlign: "center" },
        },
        {
            field: "payment",
            title: "Transaction Amount",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.payment)}</div>,
        },
        {
            field: "package",
            title: paymentColumns?.[5] || "Package",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.package)}</div>,
        },
        {
            field: "scb",
            title: paymentColumns?.[6] || "SCB",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.scb)}</div>,
        },
        {
            field: "kbank",
            title: paymentColumns?.[7] || "K Bank",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.kbank)}</div>,
        },
        {
            field: "bay",
            title: paymentColumns?.[8] || "BAY",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.bay)}</div>,
        },
        {
            field: "credit",
            title: paymentColumns?.[3] || "Credit Card",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.credit)}</div>,
        },
        {
            field: "kshop",
            title: paymentColumns?.[9] || "Kshop",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.kshop)}</div>,
        },
        {
            field: "installment",
            title: paymentColumns?.[10] || "ผ่อนผ่านบัตร",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.installment)}</div>,
        },
        {
            field: "ttb",
            title: paymentColumns?.[11] || "TTB",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.ttb)}</div>,
        },
        {
            field: "paypal",
            title: paymentColumns?.[12] || "PAYPAL",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.paypal)}</div>,
        },
        {
            field: "uob",
            title: paymentColumns?.[13] || "UOB",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.uob)}</div>,
        },
        {
            field: "transfer",
            title: paymentColumns?.[2] || "Transfer",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.transfer)}</div>,
        },
        {
            field: "other",
            title: paymentColumns?.[4] || "Other",
            cellStyle: { textAlign: "center" },
            render: obj => <div>{currencyTHB(obj?.other)}</div>,
        },
        {
            field: "status",
            title: "Status",
            cellStyle: { textAlign: "center" },
            render: obj => (
                <div>
                    {Number(obj?.status)
                        ? `${obj?.status}${getOrdinalSuffix(Number(obj?.status))} Payment`
                        : capitalize(obj?.status)}
                </div>
            ),
        },
        {
            field: "user",
            title: "User",
            cellStyle: { textAlign: "center" },
        },
    ];
    return column;
};
